import { render } from "./btcNftPreview.vue?vue&type=template&id=d72d36cc&scoped=true"
import script from "./btcNftPreview.vue?vue&type=script&lang=js"
export * from "./btcNftPreview.vue?vue&type=script&lang=js"

import "./btcNftPreview.vue?vue&type=style&index=0&id=d72d36cc&scoped=true&lang=scss"

import exportComponent from "/home/projects/endangeredlabs-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d72d36cc"]])

export default __exports__